<template>
  <div class="zpagenav">
    <nav class="zpagenav">
    <ul class="pagination">
      <li :key="index" v-for="(unit, index) in units" :class="'page-item ' + unit.class" :disabled="unit.disabled">
        <div @click="setPage(unit.page)" class="page-link" :aria-label="unit.ariaLabel">
          <span v-if="unit.isPager" aria-hidden="true" v-html="unit.html"></span>
          <span v-else v-html="unit.html"></span>
          <span v-if="unit.isPager" class="sr-only" v-html="unit.srHtml"></span>
          </div>
        </li>
        <li v-if="searchBool" class="page-item item-search">至<input type="number" v-model="num" />页 <span @click="sure">确认</span></li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'zpagenav',
  props: {
    page: Number,
    total: Number,
    pageSize: Number,
    maxLink: Number,
    pageHandler: Function,
    createUrl: Function
  },
  data () {
    return {
      config: {
        page: 1,
        pageSize: 10,
        total: 0,
        prevHtml: '上一页',
        nextHtml: '下一页',
        prevSrHtml: '',
        nextSrHtml: '',
        dotsHtml: '...',
        searchBool: 1
      },
      num: ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    setPage: function (page) {
      if (page === this.page) return false
      if (this.pageHandler) this.pageHandler(page)
      this.jumpPosition()
    },
    sure: function () {
      let n = this.num
      if (n <= Math.ceil(this.total / this.pageSize) && n > 0) {
        if (this.pageHandler) this.pageHandler(n)
        this.jumpPosition()
      } else {
        this.num = ''
      }
    },
    jumpPosition: function () {
      $('html,body').animate({ scrollTop: $('.jump-position').offset().top - 150 }, 800)
    }
  },
  computed: {
    units: function () {
      let th = this
      let option = th.config
      let page = th.page || option.page
      let pageSize = th.pageSize || option.pageSize
      let total = th.total || option.total
      let maxLink = th.maxLink > 5 ? th.maxLink : 5

      let linksCount = Math.ceil(total / pageSize)
      th.searchBool = linksCount < maxLink ? 0 : 1

      if (page > linksCount) page = linksCount + 0

      let hasPrev = page > 1
      let hasNext = page < linksCount
      let realMaxLink = maxLink > linksCount ? linksCount : maxLink

      let units = []
      let arr = computeLens()

      units.push({
        class: hasPrev ? '' : 'disabled',
        page: hasPrev ? page - 1 : page,
        isPager: true,
        isPrev: true,
        isNext: false,
        html: option.prevHtml,
        srHtml: option.prevSrHtml,
        ariaLabel: option.prevSrHtml
      })

      let dotUnit = {
        class: 'disabled',
        page: page,
        isPager: false,
        isPrev: false,
        isNext: true,
        html: option.dotsHtml
      }

      for (let i = 0, len = arr.length; i < len; i++) {
        pushUnit(arr[i])
      }

      units.push({
        class: hasNext ? '' : 'disabled',
        page: hasNext ? page + 1 : page,
        isPager: true,
        isPrev: false,
        isNext: true,
        html: option.nextHtml,
        srHtml: option.nextSrHtml,
        ariaLabel: option.nextSrHtml
      })

      function pushUnit (i) {
        if (typeof i === 'number') {
          units.push({
            page: i,
            isPrev: false,
            isPager: false,
            disabled: false,
            class: i === page ? 'active' : '',
            isNext: false,
            html: i
          })
        } else units.push(dotUnit)
      }

      function computeLens () {
        let a4 = Math.floor((realMaxLink - 2) / 2)
        let a5 = realMaxLink - 2 - a4
        let s2 = page - a4
        let s3 = page + a5
        if (s2 < 2) {
          s2 = 2
        } else if (s3 > linksCount) {
          s2 = linksCount - (realMaxLink - 2)
        }
        let arr = [1]
        if (s2 > 2) arr.push('dot')
        let it
        for (let i = 0, len = realMaxLink - 2 < 1 ? realMaxLink - 1 : realMaxLink - 2; i < len; i++) {
          it = i + s2
          arr.push(it)
        }
        if (it < linksCount - 1) arr.push('dot')
        if (it < linksCount) arr.push(linksCount)
        return arr
      }

      return units
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .sr-only-focusable:active, .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
  }
  .m-r-1 {
    margin-right: 1rem!important;
  }
  .zpagenav{
    text-align: center;
  }
  .pagination {
    display: inline-block;
    padding-left: 0;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-radius: .25rem;
  }

  .page-item {
    display: inline;
  }

  .page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .page-item:last-child .page-link {
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .page-item.active .page-link, .page-item.active .page-link:focus, .page-item.active .page-link:hover {
    z-index: 2;
    color: #fff;
    cursor: default;
    background-color: #248DDF;
  }

  .page-item.disabled .page-link, .page-item.disabled .page-link:focus, .page-item.disabled .page-link:hover {
    color: #818a91;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
  }
  .item-search{
    color: #999999;
  }
  .page-link {
    float: left;
    text-decoration: none;
    width: 70px;
    height: 40px;
    background: #fff;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    margin-right: 11px;
    color: #999999;
    cursor: pointer;
  }
  .item-search span{
    display: inline-block;
    width: 70px;
    height: 40px;
    background: #248DDF;
    border-radius: 4px;
    color: white;
    text-align: center;
    line-height: 40px;
    margin-left: 10px;
    cursor: pointer;
  }

  .page-link:focus, .page-link:hover {
    color: #014c8c;
    background-color: #eceeef;
  }

  .pagination-lg .page-link {
    padding: .75rem 1.5rem;
    font-size: 1.25rem;
    line-height: 1.333333;
  }

  .pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: .3rem;
    border-bottom-left-radius: .3rem;
  }

  .pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  }

  .pagination-sm .page-link {
    padding: .275rem .75rem;
    font-size: .875rem;
    line-height: 1.5;
  }

  .pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: .2rem;
    border-bottom-left-radius: .2rem;
  }

  .pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: .2rem;
    border-bottom-right-radius: .2rem;
  }
  input {
    display: inline-block;
    width: 70px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 0 5px;
    text-align: center;
    margin: 0 6px;
  }

  .pager {
    padding-left: 0;
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-align: center;
    list-style: none;
  }

  .pager::after {
    display: table;
    clear: both;
    content: "";
  }

  .pager li {
    display: inline;
  }

  .pager li > a,
  .pager li > span {
    display: inline-block;
    padding: 5px 14px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 15px;
  }

  .pager li > a:focus, .pager li > a:hover {
    text-decoration: none;
    background-color: #eceeef;
  }

  .pager .disabled > a, .pager .disabled > a:focus, .pager .disabled > a:hover {
    color: #818a91;
    cursor: not-allowed;
    background-color: #fff;
  }

  .pager .disabled > span {
    color: #818a91;
    cursor: not-allowed;
    background-color: #fff;
  }

  .pager-next > a,
  .pager-next > span {
    float: right;
  }

  .pager-prev > a,
  .pager-prev > span {
    float: left;
  }

  .screen2 .page-link,.screen3 .page-link {
    width: 50px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
    margin-right: 7px;
  }
  .screen2 .item-search,.screen3 .item-search{
    line-height: 30px;
    font-size: 14px;
  }
  .screen3 .item-search{
    display: block;
    text-align: center;
    padding-top: 38px;
  }
  .screen2 input,.screen3 input{
    width: 50px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
  .screen2 .item-search span,.screen3 .item-search span{
    width: 50px;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/zpagenav.vue